var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    {
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-list" } },
            [
              _vm.saleLayouts.length > 0 && !_vm.ignoreSaleLayouts
                ? [
                    _c(
                      "w-list-item",
                      {
                        attrs: { disabled: _vm.confirming },
                        on: {
                          click: function ($event) {
                            return _vm.toggleAllSaleLayoutsChecked()
                          },
                        },
                      },
                      [
                        _c(
                          "w-list-item-icon",
                          { staticClass: "title-text" },
                          [
                            _vm.allSaleLayoutsChecked()
                              ? _c("w-fa", { attrs: { icon: "check" } })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c("w-list-item-text", { staticClass: "title-text" }, [
                          _vm._v(_vm._s(_vm.$ct("all-sale-layouts"))),
                        ]),
                      ],
                      1
                    ),
                    _vm._l(_vm.saleLayouts, function (item) {
                      return _c(
                        "w-list-item",
                        {
                          key: `sale-${item.ID}`,
                          attrs: { disabled: _vm.confirming },
                          on: {
                            click: function ($event) {
                              return _vm.toggleSaleLayout(item)
                            },
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [
                              _vm.getSaleLayoutChecked(item)
                                ? _c("w-fa", { attrs: { icon: "check" } })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("w-list-item-text", [_vm._v(_vm._s(item.Name))]),
                        ],
                        1
                      )
                    }),
                  ]
                : _vm._e(),
              _vm.reminderLayouts.length > 0 && !_vm.ignoreReminderLayouts
                ? [
                    _c(
                      "w-list-item",
                      {
                        attrs: { disabled: _vm.confirming },
                        on: {
                          click: function ($event) {
                            return _vm.toggleAllReminderLayoutsChecked()
                          },
                        },
                      },
                      [
                        _c(
                          "w-list-item-icon",
                          { staticClass: "title-text" },
                          [
                            _vm.allReminderLayoutsChecked()
                              ? _c("w-fa", { attrs: { icon: "check" } })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c("w-list-item-text", { staticClass: "title-text" }, [
                          _vm._v(_vm._s(_vm.$ct("all-reminder-layouts"))),
                        ]),
                      ],
                      1
                    ),
                    _vm._l(_vm.reminderLayouts, function (item) {
                      return _c(
                        "w-list-item",
                        {
                          key: `reminder-${item.ID}`,
                          attrs: { disabled: _vm.confirming },
                          on: {
                            click: function ($event) {
                              return _vm.toggleReminderLayout(item)
                            },
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [
                              _vm.getReminderLayoutChecked(item)
                                ? _c("w-fa", { attrs: { icon: "check" } })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("w-list-item-text", [_vm._v(_vm._s(item.Name))]),
                        ],
                        1
                      )
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban", disabled: _vm.confirming },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: {
                    icon: "check",
                    disabled: _vm.confirming || !_vm.hasItemsSelected,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }